import React, { useMemo } from 'react';
import { Button, Container, Paper, Box, styled } from '@mui/material';
import { Add, Info } from '@mui/icons-material';
import { Subheader } from 'components';
import TrainingPlanDrillList from 'features/trainingPlan/trainingPlanDrill/TrainingPlanDrillList';
import { useNavigate } from 'react-router-dom';

const InfoContainer = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	height: 50,
	backgroundColor: '#fff8c4',
	borderRadius: 5,
	gap: 10,
	marginBottom: 20
});

const InfoText = styled(Box)({
	alignItems: 'center',
	color: '#757575'
});

const TrainingPlanDrills = () => {
	const navigate = useNavigate();

	const handleAddNew = () => {
		navigate('/training-plan-drills/new');
	};

	const createButton = useMemo(() => {
		return (
			<Button
				variant="contained"
				startIcon={<Add />}
				onClick={handleAddNew}
				color="primary"
			>
				{'Benchmark Drill'}
			</Button>
		);
	}, []);

	return (
		<>
			<Subheader title="Benchmark Drills" buttons={[createButton]} />
			<Container maxWidth="lg">
				<Paper>
					<TrainingPlanDrillList
						title={'Drills'}
						handleAddClick={handleAddNew}
					/>
				</Paper>
			</Container>
		</>
	);
};

export default TrainingPlanDrills;
